import React, { useEffect } from 'react';
import { useTenant } from '../../../../Context/Tenant/TenantContext';
import { SET_NOTIFICATION_MESSAGE, TOGGLE_SHOW_NOTIFICATION, SET_NOTIFICATION_TYPE } from '../TenantEvents';
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";

const TenantNotification = () => {

    const { state, dispatch } = useTenant();

    const handleClose = () => {
        dispatch({ type: SET_NOTIFICATION_MESSAGE, payload: "" });
        dispatch({ type: TOGGLE_SHOW_NOTIFICATION });
        dispatch({ type: SET_NOTIFICATION_TYPE, payload: "error" });
    }

    // Auto dismiss notification after 3 seconds
    useEffect(() => {
        if (state.showNotification) {
            const timer = setTimeout(() => {
                handleClose();
            }, 3000);
            // Clear timeout if component unmounts or notification changes
            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <NotificationGroup style={{ top: 0, left: "50%", transform: "translateX(-50%)" }}>
            <Notification
                key={state.noticationType || "error"}
                closable={true}
                onClose={handleClose}  // ✅ onClose 
                type={{
                    style: state.noticationType || "error",
                }}
            >
                {state.notificationMessage}
            </Notification>
        </NotificationGroup>
    )
}

export default TenantNotification;